// @flow

import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';

import {loadScript} from '../../../analytics/utils';
import {getStripeSessionClientSecret} from '../../tiers/promises';
import {useToastActions} from '../../toast-alert/utils';
import InlineLoader from '../../../elements/LoadingSpinner/InlineLoader';
import env from '../../../environment';
import SwitchTabs from '../../../elements/SwitchTabs/SwitchTabs';

type Props = {};

const useStyles = makeStyles(theme => ({
  trialCard: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  titlePro: {
    fontWeight: 600,
    fontSize: 24,
  },
  planCard: {
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    border: `1px solid ${colors.grey300}`,
    borderRadius: 12,
    padding: theme.spacing(8, 2, 2),
  },
  offerPrice: {
    color: colors.grey600,
    fontSize: 14,
    fontWeight: 500,
  },
  content: {
    margin: theme.spacing(4, 0),
  },
  price: {
    fontSize: 32,
    fontWeight: 700,
    color: colors.grey900,
  },
  priceContent: {
    marginBottom: theme.spacing(2),
  },
  selectPlanBtn: {
    borderRadius: '10px!important',
  },
  divider: {
    width: '100%',
    backgroundColor: colors.grey300,
    margin: theme.spacing(2, 0),
  },
  featuresTitle: {
    fontWeight: 600,
    color: colors.grey900,
  },
  featureName: {
    // fontWeight: 600,
    fontSize: 16,
    color: colors.grey900,
  },
  headerPlan: {
    width: '100%',
    padding: theme.spacing(1, 0),
    background: 'linear-gradient(180deg, #E4DDFE 0%, #C8B0F9 190.63%)',
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    fontSize: 12,
    color: '#3E0C9D',
    fontWeight: 500,
  },
  planCardWrap: {
    height: '100%',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  mobileContentWrap: {
    padding: theme.spacing(0, 2),
    margin: theme.spacing(3, 0),
  },
  tabsGroup: {
    width: '20rem',
  },
  tabsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16,
  },
  pricingTableHidden: {
    display: 'none',
  },
}));

const PLAN_TABS = [
  {label: 'Plan Standard', value: 'default'},
  {label: 'IA', value: 'ai_plans'},
];

function TierComparison(props: Props) {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState('default');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const [
    customerSessionClientSecret,
    setCustomerSessionClientSecret,
  ] = useState();

  const {showToast} = useToastActions();

  const history = useHistory();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadScript('https://js.stripe.com/v3/pricing-table.js', {
      async: true,
    });
    setLoading(true);

    getStripeSessionClientSecret()
      .then(clientSecret => {
        setCustomerSessionClientSecret(clientSecret.clientSecret);
      })
      .catch(error => {
        showToast({
          message: 'Ocurrió un error al cargar los planes de TiendaDa',
          title: 'Error',
          type: 'danger',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [history, showToast]);

  return (
    <div className={classes.trialCard}>
      <Typography
        component="span"
        variant="h6"
        className={classes.title}
        align="center"
        gutterBottom
      >
        ¡Tu tienda ha sido creada!
      </Typography>
      <Typography align="center">
        Selecciona el plan indicado para ti.
        <br /> Recuerda que puedes cambiarlo cuando quieras.
      </Typography>

      <div className={classes.tabsContainer}>
        <SwitchTabs
          value={selectedTab}
          onChange={handleTabChange}
          labels={PLAN_TABS}
        />
      </div>

      <div className={classes.content}>
        {loading && <InlineLoader loading size={40} />}
        {customerSessionClientSecret &&
          Object.entries(env.stripePricingTables).map(([key, table]) => (
            <div
              key={key}
              className={
                selectedTab !== key ? classes.pricingTableHidden : undefined
              }
            >
              <stripe-pricing-table
                pricing-table-id={table.tableId}
                publishable-key={table.publishableKey}
                customer-session-client-secret={customerSessionClientSecret}
              ></stripe-pricing-table>
            </div>
          ))}
      </div>
    </div>
  );
}

export default TierComparison;
